/**
 * Localization messages for RuleCardCondition component
 */
import sharedMessages from '../../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../../utils/localization';

const componentMessages = {
  // Component-specific messages
  'Rule Condition': 'ruleRecs.ruleCardCondition.title',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type RuleCardConditionMessage = keyof typeof invertedMessages;

export default invertedMessages;
